module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_21.e5b364ee.png";